var _path, _path2, _path3, _path4, _path5, _path6, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.8234 27.0573C54.7707 15.5969 69.7785 25.9009 49.3891 44.9444C48.5943 45.6867 47.3378 44.8834 47.669 43.8415C51.3684 32.2151 52.8084 23.8058 25.6163 29.7325C23.9397 30.097 23.2187 27.6717 24.8215 27.0573H24.8234Z",
    fill: "url(#paint0_radial_2203_672)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.2722 35.041C39.1403 66.9245 22.7872 74.8778 16.6278 47.5509C16.3875 46.4843 17.7064 45.7916 18.4349 46.6007C26.5699 55.6454 33.0718 61.1065 41.5776 34.398C42.1018 32.7512 44.5466 33.3351 44.2722 35.0429V35.041Z",
    fill: "url(#paint1_radial_2203_672)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6901 48.0337C2.87467 27.6107 4.22008 9.35145 30.7689 17.6367C31.804 17.9592 31.7415 19.459 30.6818 19.6899C18.8475 22.2716 10.9055 25.2178 29.59 46.0015C30.7424 47.2838 29.0185 49.1252 27.6901 48.0318V48.0337Z",
    fill: "url(#paint2_radial_2203_672)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8262 43.4465C13.2179 42.9523 13.6815 42.5287 14.1962 42.1776C12.0182 39.6817 10.1827 37.2107 8.74264 34.8159C8.4096 34.2645 8.07656 33.6786 7.75298 33.0661L1.41381 44.1373C-2.60352 51.1555 2.41862 59.9273 10.4552 59.9273H15.5038C13.937 56.8876 12.6445 53.1266 11.6454 48.694C11.2272 46.8373 11.6568 44.9254 12.8262 43.4465Z",
    fill: "url(#paint3_radial_2203_672)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M47.6612 17.1292L41.3106 6.037C37.2914 -0.981226 27.2472 -0.981226 23.2279 6.037L20.6885 10.4716C24.0814 10.6185 27.9738 11.3741 32.2806 12.7175C34.7236 13.4788 36.4229 15.677 36.6045 18.2035C40.1639 17.4822 43.4925 17.1101 46.4974 17.1101C46.8948 17.1101 47.2827 17.1158 47.6612 17.1292Z",
    fill: "url(#paint4_radial_2203_672)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M63.1254 44.1372L60.5916 39.7122C58.8829 42.4256 56.3907 45.4291 52.8597 48.7264C51.713 49.7968 50.2294 50.3865 48.6816 50.3865C47.7392 50.3865 46.8195 50.1651 45.9907 49.7587C44.7891 53.3422 43.3926 56.5212 41.8277 59.2041C41.6839 59.4502 41.5382 59.6926 41.3944 59.9273H54.084C62.1206 59.9273 67.1427 51.1555 63.1254 44.1372Z",
    fill: "url(#paint5_radial_2203_672)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_2203_672",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0.773331) rotate(44.4819) scale(90.4579 255.796)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCB7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B292F4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_2203_672",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0.773331) rotate(44.4819) scale(90.4579 255.796)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCB7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B292F4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_2203_672",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0.773331) rotate(44.4819) scale(90.4579 255.796)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCB7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B292F4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_2203_672",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0.773331) rotate(44.4819) scale(90.4579 255.796)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCB7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B292F4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_2203_672",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0.773331) rotate(44.4819) scale(90.4579 255.796)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCB7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B292F4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_2203_672",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0.773331) rotate(44.4819) scale(90.4579 255.796)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCB7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B292F4"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.57747b052da50756476d888d3bc07856.svg";
export { ForwardRef as ReactComponent };